import { Union } from "../fable-library.3.7.20/Types.js";
import { union_type, lambda_type, option_type, tuple_type, class_type, int32_type } from "../fable-library.3.7.20/Reflection.js";
import { InstancePool$1__ReleaseInstance_2B595, InstancePool$1__ClaimInstance, InstancePool$1_$ctor_9CB17FF } from "./More.fs.js";
import { tryPick, map, fill } from "../fable-library.3.7.20/Array.js";
import { curry, equals, disposeSafe, getEnumerator } from "../fable-library.3.7.20/Util.js";
import { addToDict } from "../fable-library.3.7.20/MapUtil.js";
import { map as map_1, some, value as value_1 } from "../fable-library.3.7.20/Option.js";
import { append, toArray, empty, cons, tail, head, isEmpty, singleton } from "../fable-library.3.7.20/List.js";

export function DataStream_ofString(s) {
    const sLength = s.length | 0;
    return {
        CanRead(i) {
            return i < sLength;
        },
        Read(i_1) {
            return s[i_1];
        },
        TryRead(i_2, c) {
            if (i_2 < sLength) {
                c.contents = s[i_2];
                return true;
            }
            else {
                return false;
            }
        },
    };
}

export class Parser$2 extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Parser"];
    }
}

export function Parser$2$reflection(gen0, gen1) {
    return union_type("Svea.Dry.Parser`2", [gen0, gen1], Parser$2, () => [[["Item", lambda_type(int32_type, lambda_type(class_type("Svea.Dry.DataStream`1", [gen0]), option_type(tuple_type(gen1, int32_type))))]]]);
}

export const Parser_charBuffers = InstancePool$1_$ctor_9CB17FF(() => fill(new Array(4 * 1024), 0, 4 * 1024, ""));

export function Parser_generateCharMemberTest(chars) {
    const cs = new Map([]);
    const enumerator = getEnumerator(chars);
    try {
        while (enumerator["System.Collections.IEnumerator.MoveNext"]()) {
            addToDict(cs, enumerator["System.Collections.Generic.IEnumerator`1.get_Current"](), true);
        }
    }
    finally {
        disposeSafe(enumerator);
    }
    return (arg) => cs.has(arg);
}

export function Parser_item() {
    return new Parser$2(0, (i, s) => (s.CanRead(i) ? [s.Read(i), i + 1] : (void 0)));
}

export function Parser_sat(pred) {
    return new Parser$2(0, (i, s) => {
        if (s.CanRead(i)) {
            const x = s.Read(i);
            return pred(x) ? [x, i + 1] : (void 0);
        }
        else {
            return void 0;
        }
    });
}

export function Parser_collect(collector) {
    return new Parser$2(0, (i, s) => {
        if (s.CanRead(i)) {
            const matchValue = collector(s.Read(i));
            return (matchValue == null) ? (void 0) : [value_1(matchValue), i + 1];
        }
        else {
            return void 0;
        }
    });
}

export function Parser_tChar(c) {
    return new Parser$2(0, (i, s) => ((s.CanRead(i) && equals(c, s.Read(i))) ? [c, i + 1] : (void 0)));
}

export function Parser_ch(c) {
    return new Parser$2(0, (i, s) => ((s.CanRead(i) && equals(c, s.Read(i))) ? [singleton(c), i + 1] : (void 0)));
}

export function Parser_any(ps) {
    const pFns$0027 = map((_arg) => curry(2, _arg.fields[0]), ps);
    return new Parser$2(0, (i, s) => tryPick((pFn) => pFn(i)(s), pFns$0027));
}

export function Parser_any2(_arg_1, _arg) {
    return new Parser$2(0, (i, s) => {
        const matchValue = _arg_1.fields[0](i, s);
        return (matchValue != null) ? matchValue : _arg.fields[0](i, s);
    });
}

export function Parser_any3(_arg_2, _arg_1, _arg) {
    return new Parser$2(0, (i, s) => {
        const matchValue = _arg_2.fields[0](i, s);
        if (matchValue == null) {
            const matchValue_1 = _arg_1.fields[0](i, s);
            return (matchValue_1 == null) ? _arg.fields[0](i, s) : matchValue_1;
        }
        else {
            return matchValue;
        }
    });
}

export function Parser_any4(_arg_3, _arg_2, _arg_1, _arg) {
    return new Parser$2(0, (i, s) => {
        const matchValue = _arg_3.fields[0](i, s);
        if (matchValue == null) {
            const matchValue_1 = _arg_2.fields[0](i, s);
            if (matchValue_1 == null) {
                const matchValue_2 = _arg_1.fields[0](i, s);
                return (matchValue_2 == null) ? _arg.fields[0](i, s) : matchValue_2;
            }
            else {
                return matchValue_1;
            }
        }
        else {
            return matchValue;
        }
    });
}

export function Parser_op_LessBarBarGreater(p, q) {
    return Parser_any2(p, q);
}

export function Parser_sequence(_arg) {
    if (!isEmpty(_arg)) {
        return new Parser$2(0, (i_2, s_1) => {
            let r, arg10$0040;
            const matchValue_1 = head(_arg).fields[0](i_2, s_1);
            if (matchValue_1 == null) {
                return void 0;
            }
            else {
                const i_1_2 = matchValue_1[1] | 0;
                return ((r = matchValue_1[0], (arg10$0040 = Parser_sequence(tail(_arg)), new Parser$2(0, (i_1, s) => {
                    const matchValue = arg10$0040.fields[0](i_1, s);
                    return (matchValue == null) ? (void 0) : [cons(r, matchValue[0]), matchValue[1]];
                })))).fields[0](i_1_2, s_1);
            }
        });
    }
    else {
        return new Parser$2(0, (i, _arg_1) => [empty(), i]);
    }
}

export function Parser_textStr_(str, ctor, i, s) {
    const strLen = str.length | 0;
    const textStr$0027 = (i$0027_mut, si_mut) => {
        textStr$0027:
        while (true) {
            const i$0027 = i$0027_mut, si = si_mut;
            if (strLen > si) {
                if (str[si] === s.Read(i$0027)) {
                    i$0027_mut = (i$0027 + 1);
                    si_mut = (si + 1);
                    continue textStr$0027;
                }
                else {
                    return void 0;
                }
            }
            else {
                return [ctor(str), i$0027];
            }
            break;
        }
    };
    if (s.CanRead((i + strLen) - 1)) {
        return textStr$0027(i, 0);
    }
    else {
        return void 0;
    }
}

export function Parser_textStr(str, ctor) {
    return new Parser$2(0, (i, s) => Parser_textStr_(str, ctor, i, s));
}

export function Parser_ignoreStr(str) {
    return Parser_textStr(str, (value) => {
    });
}

export function Parser_pOptional(_arg) {
    return new Parser$2(0, (i, s) => {
        let matchValue;
        return (matchValue = _arg.fields[0](i, s), (matchValue != null) ? [some(matchValue[0]), matchValue[1]] : [void 0, i]);
    });
}

export function Parser_zeroOrOne(_arg) {
    return new Parser$2(0, (i, s) => {
        const matchValue = _arg.fields[0](i, s);
        return (matchValue == null) ? [empty(), i] : matchValue;
    });
}

function Parser_pFold_(foldFn, resFn, seed, pFn, i, s) {
    const pFold_$0027 = (acc_mut, i$0027_mut) => {
        pFold_$0027:
        while (true) {
            const acc = acc_mut, i$0027 = i$0027_mut;
            const matchValue = pFn(i$0027, s);
            if (matchValue != null) {
                const i$0027$0027 = matchValue[1];
                acc_mut = foldFn(matchValue[0], acc);
                i$0027_mut = i$0027$0027;
                continue pFold_$0027;
            }
            else {
                return [resFn(acc), i$0027];
            }
            break;
        }
    };
    return pFold_$0027(seed, i);
}

export function Parser_pFold(fn, seed, _arg) {
    return new Parser$2(0, (i, s) => Parser_pFold_(fn, (x) => x, seed, _arg.fields[0], i, s));
}

export function Parser_manyFold(_arg, foldFn, seed, ctor) {
    return new Parser$2(0, (i, s) => Parser_pFold_(foldFn, ctor, seed, _arg.fields[0], i, s));
}

export function Parser_many(p, ctor) {
    return Parser_manyFold(p, cons, empty(), ctor);
}

export function Parser_many1(_arg, ctor) {
    const pFn = _arg.fields[0];
    return new Parser$2(0, (i, s) => {
        const matchValue = pFn(i, s);
        return (matchValue == null) ? (void 0) : Parser_pFold_(cons, ctor, singleton(matchValue[0]), pFn, matchValue[1], s);
    });
}

export function Parser_textWhile(pred) {
    return new Parser$2(0, (i, s) => {
        const collect = (buffer_mut, bufferIndex_mut, i$0027_mut) => {
            collect:
            while (true) {
                const buffer = buffer_mut, bufferIndex = bufferIndex_mut, i$0027 = i$0027_mut;
                if (s.CanRead(i$0027)) {
                    const c = s.Read(i$0027);
                    if (pred(c)) {
                        buffer[bufferIndex] = c;
                        buffer_mut = buffer;
                        bufferIndex_mut = (bufferIndex + 1);
                        i$0027_mut = (i$0027 + 1);
                        continue collect;
                    }
                    else {
                        return [buffer.join('').substr(0, bufferIndex), i$0027];
                    }
                }
                else {
                    return [buffer.join('').substr(0, bufferIndex), i$0027];
                }
                break;
            }
        };
        const charBuffer = InstancePool$1__ClaimInstance(Parser_charBuffers);
        try {
            return collect(charBuffer, 0, i);
        }
        finally {
            InstancePool$1__ReleaseInstance_2B595(Parser_charBuffers, charBuffer);
        }
    });
}

export function Parser_ignoreWhile_(pred, i, s) {
    const ignore = (i$0027_mut) => {
        ignore:
        while (true) {
            const i$0027 = i$0027_mut;
            if (s.CanRead(i$0027) && pred(s.Read(i$0027))) {
                i$0027_mut = (i$0027 + 1);
                continue ignore;
            }
            else {
                return i$0027 | 0;
            }
            break;
        }
    };
    return ignore(i) | 0;
}

function Parser_sepBy_(p, sep, foldFn, seed, ctor, i, s) {
    const matchValue = p(i, s);
    if (matchValue == null) {
        return void 0;
    }
    else {
        const i$0027 = matchValue[1] | 0;
        return Parser_pFold_(foldFn, ctor, foldFn(matchValue[0], seed), (i$0027$0027, _arg) => {
            const matchValue_1 = sep(i$0027$0027, s);
            return (matchValue_1 == null) ? (void 0) : p(matchValue_1[1], s);
        }, i$0027, s);
    }
}

export function Parser_sepby1(_arg_1, _arg, ctor) {
    return new Parser$2(0, (i, s) => Parser_sepBy_(_arg_1.fields[0], _arg.fields[0], cons, empty(), ctor, i, s));
}

export function Parser_sepbyFold(_arg_1, _arg, foldFn, seed, ctor) {
    return new Parser$2(0, (i, s) => {
        const matchValue = Parser_sepBy_(_arg_1.fields[0], _arg.fields[0], foldFn, seed, ctor, i, s);
        return (matchValue == null) ? [ctor(seed), i] : matchValue;
    });
}

export function Parser_sepby(p, sep, ctor) {
    return Parser_sepbyFold(p, sep, cons, empty(), ctor);
}

export function Parser_chainl(p, op) {
    return Parser_zeroOrOne(Parser_chainl1(p, op));
}

export function Parser_chainl1(p, op) {
    const rest = (r) => Parser_op_LessBarBarGreater(new Parser$2(0, (i_2, s_1) => {
        let f;
        const matchValue_1 = op.fields[0](i_2, s_1);
        return (matchValue_1 == null) ? (void 0) : ((f = matchValue_1[0], new Parser$2(0, (i, s) => {
            const matchValue = p.fields[0](i, s);
            if (matchValue == null) {
                return void 0;
            }
            else {
                const i_1 = matchValue[1] | 0;
                return rest(f(r)(matchValue[0])).fields[0](i_1, s);
            }
        }))).fields[0](matchValue_1[1], s_1);
    }), new Parser$2(0, (i_3, _arg_2) => [r, i_3]));
    return new Parser$2(0, (i_4, s_2) => {
        const matchValue_2 = p.fields[0](i_4, s_2);
        if (matchValue_2 == null) {
            return void 0;
        }
        else {
            const i_1_2 = matchValue_2[1] | 0;
            return rest(matchValue_2[0]).fields[0](i_1_2, s_2);
        }
    });
}

export function Parser_isSpace(c) {
    if (c === " ") {
        return true;
    }
    else if (c >= "\t") {
        return c <= "\r";
    }
    else {
        return false;
    }
}

export const Parser_space = Parser_textWhile(Parser_isSpace);

export function Parser_ignoreSpaceAs(x) {
    return new Parser$2(0, (i, s) => [x, Parser_ignoreWhile_(Parser_isSpace, i, s)]);
}

export function Parser_token(p) {
    return new Parser$2(0, (i, s) => {
        const matchValue = p.fields[0](i, s);
        if (matchValue == null) {
            return void 0;
        }
        else {
            const i_1 = matchValue[1] | 0;
            return Parser_ignoreSpaceAs(matchValue[0]).fields[0](i_1, s);
        }
    });
}

export function Parser_EOF(p) {
    return new Parser$2(0, (i_1, s_1) => {
        let x;
        const matchValue_1 = p.fields[0](i_1, s_1);
        return (matchValue_1 == null) ? (void 0) : ((x = matchValue_1[0], new Parser$2(0, (i, s) => (s.CanRead(i) ? (void 0) : [x, i])))).fields[0](matchValue_1[1], s_1);
    });
}

export function Parser_symbStr(str) {
    return Parser_token(Parser_textStr(str, (x) => x));
}

export function Parser_apply(p) {
    let arg10$0040;
    return curry(2, ((arg10$0040 = Parser_ignoreSpaceAs(), new Parser$2(0, (i, s) => {
        let _arg;
        const matchValue = arg10$0040.fields[0](i, s);
        return (matchValue == null) ? (void 0) : ((_arg = matchValue[0], p)).fields[0](matchValue[1], s);
    }))).fields[0]);
}

export function Parser_cs2s(cs) {
    return toArray(cs).join('');
}

export function Parser_runParser(p, d) {
    return map_1((tupledArg) => tupledArg[0], Parser_apply(p)(0)(d));
}

export function Parser_runParserWithFailure(p, dataStream) {
    const matchValue = Parser_runParser(p, dataStream);
    if (matchValue != null) {
        return value_1(matchValue);
    }
    else {
        throw (new Error("Error parsing string"));
    }
}

export function Parser_isHexChar(c) {
    if (((c >= "A") && (c <= "F")) ? true : ((c >= "a") && (c <= "f"))) {
        return true;
    }
    else if (c >= "0") {
        return c <= "9";
    }
    else {
        return false;
    }
}

export const Parser_hexDigit = Parser_sat(Parser_isHexChar);

export function Parser_charToken_(ctor, c, i, s) {
    if (s.CanRead(i) && (c === s.Read(i))) {
        const ignoreWhiteSpace = (i$0027_mut) => {
            ignoreWhiteSpace:
            while (true) {
                const i$0027 = i$0027_mut;
                if (s.CanRead(i$0027) && Parser_isSpace(s.Read(i$0027))) {
                    i$0027_mut = (i$0027 + 1);
                    continue ignoreWhiteSpace;
                }
                else {
                    return ctor(c, i$0027);
                }
                break;
            }
        };
        return ignoreWhiteSpace(i + 1);
    }
    else {
        return void 0;
    }
}

export function Parser_charToken(c) {
    return new Parser$2(0, (i_1, s) => Parser_charToken_((c$0027, i) => [c$0027, i], c, i_1, s));
}

export function Parser_betweenChars(c1, c2, _arg) {
    return new Parser$2(0, (i, s) => Parser_charToken_((_arg_1, c1i) => {
        const matchValue = _arg.fields[0](c1i, s);
        if (matchValue == null) {
            return void 0;
        }
        else {
            const x = matchValue[0];
            return Parser_charToken_((_arg_2, c2i) => [x, c2i], c2, matchValue[1], s);
        }
    }, c1, i, s));
}

export function Parser_op_LessAtGreater(_arg_1, _arg) {
    return new Parser$2(0, (i, s) => {
        const matchValue = _arg_1.fields[0](i, s);
        if (matchValue == null) {
            return void 0;
        }
        else {
            const rp = matchValue[0];
            const matchValue_1 = _arg.fields[0](matchValue[1], s);
            if (matchValue_1 == null) {
                return void 0;
            }
            else {
                const i$0027$0027 = matchValue_1[1] | 0;
                return [append(rp, matchValue_1[0]), i$0027$0027];
            }
        }
    });
}

